import { useState, lazy } from "react";
import { Link } from "react-router-dom";
import * as routes from "../data/links/routes";
import { useAuth } from "../context/AuthContext";
import { isEmpty, isEmail } from "../helpers/functions";
import InputField from "../components/Inputs/InputField";
import { useGoogleReCaptcha } from "@google-recaptcha/react";
import RequestButton from "../components/buttons/RequestButton";
import { FormContainer, StyledLink } from "../data/style/Style";
import { handleReCaptchaVerify, captcha } from "../utils/helpers";
import { useNotifications } from "../context/NotificationContext";
import { TwoTonedHeader, DescriptionText } from "../components/theme/texts";

const Stack = lazy(() => import("@mui/material/Stack"));

const ForgotPassword = () => {
  let { RecoverPassMutation, activeRequest, setActiveRequest } = useAuth();
  const [email, setEmail] = useState("");
  const { executeV3 } = useGoogleReCaptcha();
  const { enableNotification } = useNotifications();
  const [emailFocus, setEmailFocused] = useState(false);
  const [emailErrorText, setEmailErrorText] = useState(false);

  let sendEmail = async () => {
    const recoverEmail = email;
    if (isEmpty(email)) {
      setEmailErrorText("Email is required.");
      return;
    }

    if (!isEmail(email)) {
      setEmailErrorText("This is not a valid email.");
      return;
    }

    const token = await executeV3();
    await handleReCaptchaVerify(
      token,
      "password_recover",
      document.cookie.split("=")[1],
    );
    if (captcha.success) {
      setActiveRequest(true);
      RecoverPassMutation.mutate({
        recoverEmail,
      });
    } else {
      enableNotification("Something went wrong. Please try again.", "error");
    }
  };

  const canSubmit = email.trim(" ").length > 0 && isEmail(email);

  return (
    <Stack gap={2} width={"50%"} alignItems={"center"}>
      <TwoTonedHeader
        mainText={"Recover your"}
        subText={"Password"}
        fontSize={"clamp(36px,5.5vw,60px)"}
      />
      <DescriptionText style={{ fontSize: "clamp(14px,1.5vw,17px)" }}>
        Type your account email.
      </DescriptionText>
      <FormContainer>
        <div
          style={{
            height: 2,
            background:
              "linear-gradient(90deg,#f97316,#ea580c,rgba(249,115,22,.04))",
          }}
        />
        <Stack width={"90%"} p={5} gap={4} alignSelf={"center"}>
          <InputField
            id="gp-email"
            label="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onFocus={() => setEmailFocused(true)}
            onBlur={() => setEmailFocused(false)}
            focused={emailFocus}
            error={emailErrorText}
          />
          <Link
            style={{
              textDecoration: "none",
              marginTop: -15,
              alignSelf: "flex-end",
            }}
            to={routes.LOGIN}
          >
            <StyledLink sx={{ fontSize: 12 }}>Log in →</StyledLink>
          </Link>
          <RequestButton
            activeRequest={activeRequest}
            text={"Send Email"}
            onClick={sendEmail}
            loadingText={"Sending email..."}
            disabled={activeRequest || !canSubmit}
          />
        </Stack>
      </FormContainer>
    </Stack>
  );
};
export default ForgotPassword;
